/* unplugin-vue-components disabled */import { render } from "./about_m.vue?vue&type=template&id=369d20f3&scoped=true"
import script from "./about_m.vue?vue&type=script&lang=js"
export * from "./about_m.vue?vue&type=script&lang=js"

import "./about_m.vue?vue&type=style&index=0&id=369d20f3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369d20f3"]])

export default __exports__